import { useEffect } from 'react';

// Adapted from solution at https://github.com/vercel/next.js/issues/12530

/*const saveScrollPos = (url, storage) => {
  const scrollPos = { x: window.scrollX, y: window.scrollY };
  storage.setItem(url, JSON.stringify(scrollPos));
};

const restoreScrollPos = (url, storage) => {
  const scrollPos = JSON.parse(storage.getItem(url));
  if (scrollPos) {
    window.scrollTo(scrollPos.x, scrollPos.y);
  }
};

const useScrollRestoration = () => {
  const storage = getStorage(StorageType.Session);

  const router = useRouter();
  useEffect(() => {
    if (!storage) return;

    if (
      typeof window === 'undefined' ||
      !('scrollRestoration' in window.history)
    ) {
      return;
    }

    let shouldScrollRestore = false;
    window.history.scrollRestoration = 'manual';
    restoreScrollPos(router.asPath, storage);

    const onBeforeUnload = event => {
      saveScrollPos(router.asPath, storage);
      delete event.returnValue;
    };

    const onRouteChangeStart = () => {
      saveScrollPos(router.asPath, storage);
    };

    const onRouteChangeComplete = url => {
      if (shouldScrollRestore) {
        shouldScrollRestore = false;
        restoreScrollPos(url, storage);
      }
    };

    window.addEventListener('beforeunload', onBeforeUnload);
    Router.events.on('routeChangeStart', onRouteChangeStart);
    Router.events.on('routeChangeComplete', onRouteChangeComplete);
    Router.beforePopState(() => {
      shouldScrollRestore = true;
      return true;
    });

    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
      Router.events.off('routeChangeStart', onRouteChangeStart);
      Router.events.off('routeChangeComplete', onRouteChangeComplete);
      Router.beforePopState(() => true);
    };
  }, [router, storage]);
};*/

const usePreventScrollRestoration = () => {
  useEffect(() => {
    if (!window?.history?.scrollRestoration) return;

    window.history.scrollRestoration = 'manual';
  }, []);
};

export default usePreventScrollRestoration;
